import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/head-teacher/entrance-exam",
  },
  actions: {
    getPending({ dispatch, state }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/pending?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    confirm({ dispatch, state }, { query, data }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/confirm?${serialize(query)}`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
